module.exports = __webpack_public_path__ + "img/btn_income.11194eb5.svg";